import PropTypes from "prop-types";

import ChallengesFolderTab from "../ChallengesFolderTab";
import { containerWrapper, containerCss } from "./FolderTabsContainer.style";

const propTypes = {
  activeTab: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  setActiveTab: PropTypes.func,
};

const FolderTabsContainer = ({ activeTab, options, setActiveTab }) => {
  const handleOptionSelection = (option) => {
    setActiveTab(option);
  };

  if (options?.length <= 1) return null;

  const renderTabs = () => {
    return options?.map((option, index) => {
      return (
        <ChallengesFolderTab
          key={`${option}-tab-${index}`}
          activeTab={activeTab}
          handleOptionSelection={handleOptionSelection}
          tabName={option}
        />
      );
    });
  };

  return (
    <div css={containerWrapper} role="tablist" aria-labelledby="tablist">
      <div css={containerCss} role="tablist" aria-labelledby="tablist">
        {renderTabs()}
      </div>
    </div>
  );
};

FolderTabsContainer.propTypes = propTypes;

export default FolderTabsContainer;
